module.exports = __webpack_public_path__ + "img/portrait-092.64d512a4.jpg";